(function () {
  'use strict';

  // Safety net for the region selector fade (see shops-select-reveal.css).
  // The CSS reveals it on body.page-ready, but if the theme never sets that
  // class on a given template the selector would stay invisible — so reveal it
  // on load as well, and again on a timer in case load has already fired.

  function reveal() {
    document.querySelectorAll('.header__shops-container').forEach(function (el) {
      el.classList.add('is-ready');
    });
  }

  if (document.readyState === 'complete') {
    reveal();
  } else {
    window.addEventListener('load', reveal);
  }

  setTimeout(reveal, 1500);
})();
